/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { EmailAttachment } from '@gh/builder-shared';
import { AccountingWipRestService, Month } from '@gh/builder-shared-data';
import { DictionaryService, InitViewService } from '@gh/common-shared';
import { SlicedDataSource } from '@gh/core-data';
import { map$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';
import {
  WipApplyResponse, WipCreateAndPrintRequest, WipCreateAndPrintResponse,
  WipDetails,
  wipDetailsFromInitDto,
  wipDetailsToApplyRequestDto,
  wipDetailsToCloseEmptyYearRequestDto,
  wipDetailsToPrintRequestDto,
  wipDetailsToRecalculateRequestDto,
  wipJobsToCreateAndPrintRequestDto,
  WipJournalLogItem,
  WipPrintRequest,
  WipRecalculateResponse,
} from './wip.model';

@Injectable()
export class WipBusinessService implements InitViewService {
  constructor(private dictionaries: DictionaryService,
              private wipRest: AccountingWipRestService) {
  }

  initView(): any {
    return {
      monthDict: this.dictionaries.getByEnum(Month),
    };
  }

  init(): Observable<WipDetails> {
    return this.wipRest.init().pipe(map$(wipDetailsFromInitDto));
  }

  findLogItemsAsDataSource(): SlicedDataSource<WipJournalLogItem> {
    return this.wipRest.findLogItemsAsDataSource();
  }

  findAllJobs(details: WipDetails): Observable<WipApplyResponse> {
    return this.wipRest.apply(wipDetailsToApplyRequestDto(details));
  }

  recalculate(details: WipDetails, isPersist: boolean): Observable<WipRecalculateResponse> {
    return this.wipRest.recalculate(wipDetailsToRecalculateRequestDto(details, isPersist));
  }

  closeEmptyYear(details: WipDetails): Observable<WipRecalculateResponse> {
    return this.wipRest.closeEmptyYear(wipDetailsToCloseEmptyYearRequestDto(details));
  }

  print(request: WipPrintRequest): Observable<void> {
    return this.wipRest.print(request);
  }

  generateReport(details: WipDetails): Observable<EmailAttachment> {
    return this.wipRest.report(wipDetailsToPrintRequestDto(details));
  }

  createAndPrintWipJobsReport(details: WipCreateAndPrintRequest): Observable<WipCreateAndPrintResponse> {
    return this.wipRest.createAndPrintWipJobsReport(wipJobsToCreateAndPrintRequestDto(details));
  }
}
